export default {
  'pages.systemConfig.accessTokenRequired': '请输入访问令牌',
  'pages.systemConfig.action': '操作',
  'pages.systemConfig.activityDiscountFen': '活动立减(分)',
  'pages.systemConfig.addExitCommand': '添加退出指令',
  'pages.systemConfig.addExternalMcp': '添加外部MCP',
  'pages.systemConfig.addLocalMcpFunction': '添加本地MCP功能',
  'pages.systemConfig.addRole': '添加角色',
  'pages.systemConfig.addSuccess': '添加成功',
  'pages.systemConfig.adminOnly': '请使用管理员账号进行操作',
  'pages.systemConfig.advancedConfig': '高级配置（点击展开）',
  'pages.systemConfig.annualToken': '年度令牌',
  'pages.systemConfig.appConfigTitle': '应用程序配置',
  'pages.systemConfig.archiveDirPlaceholder': '例如 D:\\\\data\\\\kb_archive 或 /var/lib/kb_archive',
  'pages.systemConfig.archiveDirRequired': '开启归档时请填写归档根目录',
  'pages.systemConfig.authCardTitle': '认证配置',
  'pages.systemConfig.authorityDomains': '权威域白名单',
  'pages.systemConfig.baiduApiKey': '百度 API Key',
  'pages.systemConfig.baiduEndpoint': '百度端点',
  'pages.systemConfig.bindMemoryToDevice': '记忆绑定设备',
  'pages.systemConfig.bingEndpoint': 'Bing 端点',
  'pages.systemConfig.bochaApiKey': '博查 API Key',
  'pages.systemConfig.bochaEndpoint': '博查端点',
  'pages.systemConfig.bridgeAckMessage': '外转成功本地 TTS 提示（可空为静默）',
  'pages.systemConfig.bridgePanelTitle': 'OpenClaw 桥接',
  'pages.systemConfig.chatAutoRoute': '对话自动路由',
  'pages.systemConfig.commercialDeviceDefaultLlm': '商业授权设备默认 LLM',
  'pages.systemConfig.commercialLicenseSuffix': '{base}（需商业授权）',
  'pages.systemConfig.configJsonInvalid': '配置内容需为合法的JSON格式',
  'pages.systemConfig.configJsonPlaceholder': '粘贴完整的MCP配置JSON',
  'pages.systemConfig.configJsonRequired': '请输入配置JSON',
  'pages.systemConfig.confirmDeleteExitCommand': '确定删除这个退出指令吗？',
  'pages.systemConfig.confirmDeleteExternalMcp': '确定删除这个外部MCP配置吗？',
  'pages.systemConfig.confirmDeleteMcpFunction': '确定删除这个MCP功能吗？',
  'pages.systemConfig.confirmDeleteQuickReply': '确定删除该快捷回复词吗？',
  'pages.systemConfig.confirmDeleteRole': '确定删除这个角色吗？',
  'pages.systemConfig.continuousSpeechThresholdMs': '连续语音阈值(ms)',
  'pages.systemConfig.dataCardTitle': '数据配置',
  'pages.systemConfig.dataKbAlertDesc': '主地址对应 data-config 的 <code>mcp_rag</code>，用于建库、检索、对话 MCP 等。若填写下方「OCR 索引专用地址」，则与主实例共享同一向量库时，扫描 PDF 上传会走 <code>mcp_rag_ocr</code>，减轻主实例负载；两实例须同版本且主实例提供 <code>/pdf-preflight</code>。',
  'pages.systemConfig.dataKbAlertTitle': '主实例与 OCR 实例（可选）',
  'pages.systemConfig.default1883': '默认1883',
  'pages.systemConfig.default60': '默认 60',
  'pages.systemConfig.defaultPrompt': '默认系统提示词',
  'pages.systemConfig.delete': '删除',
  'pages.systemConfig.deleteAudio': '清理临时音频',
  'pages.systemConfig.deleteFailed': '删除失败: {error}',
  'pages.systemConfig.deleteSuccess': '删除成功',
  'pages.systemConfig.description': '描述',
  'pages.systemConfig.dialogueHistoryLengthPlaceholder': '0 表示不限制条数',
  'pages.systemConfig.disabledTag': '禁用',
  'pages.systemConfig.domainPlaceholder': '域名',
  'pages.systemConfig.edit': '编辑',
  'pages.systemConfig.emotionRecognitionPrompt': '情绪识别补充提示',
  'pages.systemConfig.emotionRecognitionGlobal': '回复语气情感增强全局开关',
  'pages.systemConfig.asrEmotionDetectionGlobal': '识别用户语气全局开关',
  'pages.systemConfig.enableCommerce': '启用商业化',
  'pages.systemConfig.enableLabel': '启用',
  'pages.systemConfig.enableMcpEndpoint': '启用MCP接入点',
  'pages.systemConfig.enableMcpFilter': '启用MCP过滤器',
  'pages.systemConfig.enabledTag': '启用',
  'pages.systemConfig.enterToAdd': '输入后回车',
  'pages.systemConfig.exitCommandAlertDesc': '服务识别到用户退出指令，会直接结束对话。',
  'pages.systemConfig.exitCommandAlertTitle': '退出指令说明',
  'pages.systemConfig.exitCommandLength': '退出指令长度应在1-50个字符之间',
  'pages.systemConfig.exitCommandPattern': '退出指令包含不允许的字符',
  'pages.systemConfig.exitCommandRequired': '请输入退出指令',
  'pages.systemConfig.exitCommandsCardTitle': '退出指令配置',
  'pages.systemConfig.expiryHours': '过期时间(小时)',
  'pages.systemConfig.expiryRequired': '请输入过期时间',
  'pages.systemConfig.externalMcpAlertDesc': '在此管理外部MCP服务。使用编辑按钮可以粘贴完整的JSON配置，服务会根据名称存储对应的MCP服务。',
  'pages.systemConfig.externalMcpAlertTitle': '外部MCP配置说明',
  'pages.systemConfig.externalMcpCardTitle': '外部MCP配置',
  'pages.systemConfig.featureDescLength': '功能描述长度应在5-500个字符之间',
  'pages.systemConfig.featureDescRequired': '请输入功能描述',
  'pages.systemConfig.featureNameLength': '功能名称长度应在2-50个字符之间',
  'pages.systemConfig.featureNamePattern': '功能名称只能包含字母、数字、中文、下划线和短横线',
  'pages.systemConfig.featureNameRequired': '请输入功能名称',
  'pages.systemConfig.fetchConfigFailed': '获取{type}配置失败{detail}: {error}',
  'pages.systemConfig.forceCreateNewConnection': '强制新建连接',
  'pages.systemConfig.forecastDaysLimit': '预报天数上限',
  'pages.systemConfig.todoOverdueGraceMinutes': '待办过期宽限(分钟)',
  'pages.systemConfig.formalApiEndpoint': '正式 API 端点',
  'pages.systemConfig.formalApiKey': '正式 API Key',
  'pages.systemConfig.formalApiProvider': '正式 API 提供商',
  'pages.systemConfig.formalEngine': '正式搜索引擎',
  'pages.systemConfig.frameDurationMs': '帧长(ms)',
  'pages.systemConfig.info.activateText': '激活时前端显示的文本，可以设置为你自己的品牌内容，如“Anime AI Chat”',
  'pages.systemConfig.info.allowedDevices': '暂未实现该功能',
  'pages.systemConfig.info.annualToken': '年度令牌（如有接入年度校验场景），对应 server.auth.annual_token。',
  'pages.systemConfig.info.bindMemoryToDevice': '开启后，短期/长期画像记忆按设备维度存储与采集；关闭则按智能体维度。',
  'pages.systemConfig.info.bridgeOpenClaw': '喵伴↔OpenClaw 桥接总开关与对话自动路由；误配可能导致每句都外转，请谨慎开启。',
  'pages.systemConfig.info.checkDeviceModeImmediately': '设备模式有chat(聊天模式)/listen(录音模式)/ban(禁用设备)，开启此项后，每次请求llm大模型都会进行检查，确保修改及时生效。',
  'pages.systemConfig.info.dailyClearQuota': '用户每次对话，会累计asr、llm、tts的字数，作为用户的使用额度。开启此项后，在检测用户额度时，如果发现已经是新的一天，会先清除用户的已用额度。',
  'pages.systemConfig.info.defaultObserverUserOnRegister': '新注册用户是否默认分配观察者角色。观察者角色的用户可以查看web控制后台的所有信息，可以自行创建修改llm大模型，用于客户体验，不建议开放给普通用户，如非必须建议关闭。',
  'pages.systemConfig.info.defaultPrompt': '全局默认系统提示词（prompt），可被智能体级配置覆盖。',
  'pages.systemConfig.info.deleteAudio': '是否在处理完成后删除临时音频文件；开启可节省磁盘空间。',
  'pages.systemConfig.info.dialogueHistoryLength': '设置对话历史的最大长度。每次请求llm会将对话历史上传，以便模型参考上下文进行回答。过长的历史会增加请求延迟和成本，建议根据实际需求设置一个合理的长度。配置为0表示不限长度，会加载本次会话的所有聊天内容。',
  'pages.systemConfig.info.emotionRecognitionPrompt': '智能体开启情绪识别时，拼入对话 LLM 的 system 提示片段（驱动【语气】等标签）。',
  'pages.systemConfig.info.emotionRecognitionGlobal': '回复语气情感增强总开关。关闭后全部智能体禁用；开启后仍由各智能体单独控制。',
  'pages.systemConfig.info.asrEmotionDetectionGlobal': '识别用户语气总开关。关闭后全量禁用，无视智能体开关。',
  'pages.systemConfig.info.enableLayeredMemory': '兼容旧版「分层记忆」总开关；长期画像采集主要受智能体「长期记忆」与下方观察池配置影响。',
  'pages.systemConfig.info.enableMCPEndPoint': '启用 MCP 接入点开关。开启后，前端可通过可见性接口展示 MCP 接入点相关的自定义服务与获取接入点按钮（需配合前端与服务端可见性配置实现）。',
  'pages.systemConfig.info.enableMCPFilter': '如果需要限制智能体使用某些mcp功能，可以开启此项。llm请求时，只携带允许的mcp功能列表。此项需配合Agent的过滤列表一起使用。',
  'pages.systemConfig.info.enableVectorMemory': '开启后，智能体可使用向量长期记忆；关闭时即使智能体选择长期记忆，也不会写入或检索记忆锚点。',
  'pages.systemConfig.info.enableWhiteList': '启用白名单功能。开启后，只有白名单中的设备才能连接到服务端。',
  'pages.systemConfig.info.enhancedEmotionOutput': '增强情感输出功能。开启后，LLM的输出会包含更丰富的情感表达信息，用于提升对话的情感体验。',
  'pages.systemConfig.info.expiry': '过期时间（小时），默认24小时有效',
  'pages.systemConfig.info.flattenedChatHistory': '有业务需求再开启此项。开启此项后，每句对话会在数据库(agent_chat_messages表)中保留一条记录。无论是否开启此项，每轮对话结束后，都会将聊天历史存储在数据库agent_dialogs表中。',
  'pages.systemConfig.info.forceCreateNewConnection': 'Mqtt/UDP传输时，是否强制每次创建新连接。开启后可以避免某些连接问题，每次新的对话都会加载最新的Agent和Device信息，修改生效更及时，但会增加服务器负载，建议根据实际情况选择。',
  'pages.systemConfig.info.importYamlTab': '仅支持从服务器导出当前内存中的完整 YAML 供查看或备份；写回数据库功能已关闭，请通过各分项配置页或直接在数据库中维护 server_configs。',
  'pages.systemConfig.info.jokeAppCode': '阿里云云市场「笑话大全」API 的 AppCode。',
  'pages.systemConfig.info.keepConversationId': '开启后每轮对话开始会加载智能体的会话ID（如已开启useDeviceConversationID，则会加载设备的会话ID），并读取之前的历史记录，在此基础上继续对话。如果不开启，每次对话会生成一个新的会话ID，适合需要每次对话独立的场景。',
  'pages.systemConfig.info.knowledgeBaseMaxDocumentsPerKb': '单个知识库允许上传的文档数量上限（写入 data-config 的 mcp_rag.max_documents_per_knowledge_base）。',
  'pages.systemConfig.info.knowledgeBaseMaxPerUser': '每个用户允许创建的知识库数量上限（写入 data-config 的 mcp_rag.max_knowledge_bases_per_user）。',
  'pages.systemConfig.info.knowledgeBaseOcrApiKey': 'OCR 实例 API Key（写入 mcp_rag_ocr.api_key），与 mcp-rag security 一致。留空保存时沿用已保存的密钥。',
  'pages.systemConfig.info.knowledgeBaseOcrServerAddr': 'OCR 专用 mcp-rag 的 HTTP 地址（写入 data-config 的 mcp_rag_ocr.addr）。须与主实例共享同一 Milvus 与元数据库；主实例关闭 pdf_ocr_enabled，本实例开启并安装 Tesseract。留空则不上传分流到 OCR 实例。',
  'pages.systemConfig.info.knowledgeBaseOcrTimeoutSeconds': '调用 OCR 实例 HTTP 的超时秒数（写入 mcp_rag_ocr.timeout_seconds），留空或 0 表示由服务端使用默认 60 秒。',
  'pages.systemConfig.info.knowledgeBaseServerAddr': '知识库服务器地址，用于配置 zhi-server 连接的 mcp-rag 服务地址。',
  'pages.systemConfig.info.knowledgeBaseUploadArchiveDir': '归档根目录的绝对路径（写入 data-config 的 mcp_rag.knowledge_base_upload_archive_dir）。需与上方开关同时启用；Windows 示例 D:\\\\data\\\\kb_archive，Linux 示例 /var/lib/kb_archive。',
  'pages.systemConfig.info.knowledgeBaseUploadArchiveEnabled': '开启后，用户通过控制台上传的知识库原始文件将按「用户 ID / 知识库 ID / 上传时间」写入下方归档根目录，便于审计与追溯；关闭则仅使用临时文件，上传至 RAG 成功后即删除。',
  'pages.systemConfig.info.llmContextLimitEnabled': '开启后，每次调用大模型前按 token 预算裁剪上下文；关闭则完全保持原行为，仅在「每次打印上下文大小」打开时打观测日志。建议先关裁剪观察日志，再开启。',
  'pages.systemConfig.info.llmContextLimitInject': '记忆/知识库注入段超预算时：head_tail=留头留尾压缩；drop_all=整段丢弃。默认 head_tail，紧张时自动降为 drop_all。',
  'pages.systemConfig.info.llmContextLimitLog': '每次调用大模型都打印 CTX_LIMIT 上下文大小日志，便于试运行观察。稳定后可关闭。',
  'pages.systemConfig.info.llmContextLimitRatio': '输入预算 = 模型 context_window × 该比例 − 输出预留。默认 0.70，给回复留出空间。',
  'pages.systemConfig.info.llmContextLimitReserved': '计算输入预算时从窗口中减去的输出预留。填 0 表示使用各模型自己的 max_tokens。仅当希望所有模型统一预留时才改这个值。',
  'pages.systemConfig.info.llmContextLimitStrict': '工具定义精简时永不摘除的工具名（可带或不带 local_ 前缀）。',
  'pages.systemConfig.info.mcpPoolConfig': 'MCP 相关连接池参数。',
  'pages.systemConfig.info.toolContentMaxBytes': '工具返回内容写回对话时的长度上限，超长则保留头尾各半、中间标注截断。单位 KB。以下字数按中文估算，若内容是英文/JSON（ASCII）实际可容纳约 3 倍字符数：约 2KB≈650 汉字、4KB≈1300 字、6KB≈2000 字、8KB≈2700 字。数值越大保留越完整但每轮消耗 token 越多，建议保持默认。',
  'pages.systemConfig.info.toolContentMaxBytesMap': '按工具名单独设置上限（KB），未配置的工具使用上方全局值。常见预置：realtime_search（联网搜索）≈2000 字、mcp_rag_ask（知识库检索）≈2700 字（字数按中文估算）。可自行添加/修改/删除条目。',
  'pages.systemConfig.info.memoryCollectionDays': '兼容字段：服务端已不再按天数将画像设为只读；写入仅受「人工锁定」控制。该数值可保留给旧版界面或观察池旁注，无业务截断含义。',
  'pages.systemConfig.info.memoryObservationPoolEnabled': '开启后，对话采集的身份信息先入观察池，跨足够多会话后再合并入 L1 画像；关闭则保持每轮直接合并的旧行为。',
  'pages.systemConfig.info.memoryPromotionMinConversations': '观察池自动晋升所需的最少「不同会话」命中数，建议 2 及以上以降低误记。',
  'pages.systemConfig.info.middleTierRole': '全局中间层系统提示（如屏蔽词/话题约束），仅在与用户对话的 LLM 请求中接在首条 system 正文末尾。',
  'pages.systemConfig.info.mqttEnabled': '启用MQTT传输方式，客户端通过mqtt连接到服务端，语音数据通过upd传输，速度更快，建议开启',
  'pages.systemConfig.info.mqttIp': '你的ip:端口（或者域名:端口），端口为外部连入的端口，如未作端口转发，可以和port相同。这个地址会在ota协议中发给客户端，由客户端连接使用。',
  'pages.systemConfig.info.mqttPort': 'mqtt的监听端口，默认使用1883端口',
  'pages.systemConfig.info.mqttQos': 'MQTT QoS 等级（0/1/2）。',
  'pages.systemConfig.info.notifyDeviceOnMcpTool': '为 true 时，每次执行 MCP/函数工具前向设备发送一条 JSON 文本（type=mcp_tool），便于屏幕展示工具名；需设备固件支持解析。',
  'pages.systemConfig.info.petMetricsInject': '是否在对话提示词中向 LLM 注入设备宠物指标（情绪/亲密/活力等）。',
  'pages.systemConfig.info.poolConfig': '通用连接池参数（pool_min_size / pool_max_size 等）。',
  'pages.systemConfig.info.quickReply': '开启后，针对"你好xx"格式的唤醒词，可以进行快速回复，提升用户体验。回复的内容配置在快速回复词中，会随机选用回复。建议开启此项。',
  'pages.systemConfig.info.quickReplyTab': '「你好xx」类唤醒时的随机短句列表，需与应用配置中「快速回复」开关同时开启。',
  'pages.systemConfig.info.realtimeSearch': '联网搜索（SERP）与正式搜索 API 相关参数；关闭 Enabled 则不走联网检索链路。',
  'pages.systemConfig.info.rechargeTab': '设备流量卡充值、微信支付与物联平台一级代理连接参数（对应 recharge 配置块）。密钥留空或填 *** 表示不修改原值。',
  'pages.systemConfig.info.recorderManagerEnable': '启用录音管理功能。开启后，管理员可以在后台查看设备的录音记录，用于管理和分析。',
  'pages.systemConfig.info.saveTtsAudio': '开启后仅保存历史对话助手 TTS 回放（user_audio/{设备}/tts/），不写 common_cache。磁盘紧张请谨慎开启。改后需新连接生效。',
  'pages.systemConfig.info.saveUserAudio': '开启后保存用户说话：用于声纹选样与历史对话用户原声回放（user_audio/{设备}/user/）。磁盘紧张请谨慎开启，并设置保留天数。',
  'pages.systemConfig.info.dialogAudioRetainHours': '历史对话回放音频可播放保留小时数（索引 + user_audio/.../user|tts 文件）。超时后前端不显示播放按钮、接口拒绝播放；物理文件由运维迁移，服务端不自动删除。建议 24 小时。默认 24。可热更新。不影响 common_cache。',
  'pages.systemConfig.dialogAudioRetainHours': '历史回放音频保留小时',
  'pages.systemConfig.info.dialogAudioArchiveRoot': '归档盘根目录（只读回落）。播放：本机 → 多实例 → 归档根+原相对路径。写入仍只写业务机本地。空=不启用。热更新立即生效。',
  'pages.systemConfig.dialogAudioArchiveRoot': '历史音频归档根目录',
  'pages.systemConfig.saveTtsAudio': '保存历史回放TTS',
  'pages.systemConfig.info.saveCommonTtsCache': '开启后将同文案 TTS 写入 common_cache 做加速复用（对话场景命中率通常不高）。默认关闭；与「保存历史回放TTS」独立。改后需新连接生效。',
  'pages.systemConfig.saveCommonTtsCache': '保存TTS同文案缓存',
  'pages.systemConfig.info.selectedModuleASR': 'selected_module 中当前选用的 ASR 配置块名称。',
  'pages.systemConfig.info.selectedModuleLLM': 'selected_module 中当前选用的 LLM 配置块名称（与配置里 LLM 下 key 一致）。',
  'pages.systemConfig.info.selectedModuleLLMCommercial': '创建默认智能体时，若绑定设备为商业授权（TenantCode 非空）则选用该 LLM 配置块名称；无效时回退到 LLM。',
  'pages.systemConfig.info.selectedModuleLLMOpenSource': '创建默认智能体时，若绑定设备为开源（TenantCode 为空）则选用该 LLM 配置块名称；无效时回退到 LLM。',
  'pages.systemConfig.info.selectedModuleTTS': 'selected_module 中当前选用的 TTS 配置块名称。',
  'pages.systemConfig.info.selectedModuleVLLLM': 'selected_module 中当前选用的视觉模型（VLLLM）配置块名称。',
  'pages.systemConfig.info.serverVersion': '服务端对外声明的版本号字符串（server.server_version）。',
  'pages.systemConfig.info.speakerDetect': '启用声纹识别功能。开启后，前端会显示声纹识别相关菜单和功能，用户可以使用声纹识别相关功能。',
  'pages.systemConfig.info.dialogGuardPipeline': '处理顺序（谁先拦谁生效）：ASR出字 → L1文本硬规则 → L2说话人硬门 → Echo回声过滤 → L2.5上下文门 → 主对话LLM(L3 dialog.no_reply)。前几层是硬拦（不进模型，仍会下发STT到屏，Echo除外）；L3是同一次生成里模型声明不回。日志统一搜：dialog_guard SKIP layer=…。推荐：总开关开 + L1开 +（有声纹则L2开）+ IntentMerge开 +「仅无声纹时注入」关 + L2.5与IntentMerge同开。儿童陪伴可在智能体强制关IntentMerge。',
  'pages.systemConfig.info.dialogGuardEnabled': '【总开关】整条「是否回复」防护链总控。关：L1/L2/L2.5/L3(dialog.no_reply) 都不生效，设备几乎有字必回。开：才按 ASR→L1→L2→Echo→L2.5→L3 过门。建议生产常开。',
  'pages.systemConfig.info.textHardRulesEnabled': '【L1】零模型。拦纯语气词「嗯/哦哦」、无意义单字；放行唤醒词、助手名、停播口令。依赖总开关。硬拦仍下发STT到设备屏，不进LLM。日志 layer=L1。建议常开。',
  'pages.systemConfig.info.speakerGuardEnabled': '【L2】零模型。已锁定说话人时：别人低相关插话硬跳过，高相关立刻换人。依赖：总开关 + 本开关 +「声纹识别」开，且本轮声纹命中；miss时本层几乎不起作用。日志 layer=L2。有声纹录入时建议开。',
  'pages.systemConfig.info.speakerHotReloadEnabled': '声纹录入/删除后热刷新本机在线连接，无需设备重连。与 L2 说话人硬门配合：新声纹可更快参与锁定/换人判断。',
  'pages.systemConfig.info.speakerQualityCheck': '声纹录入前校验时长、有效语音占比与 SNR。建议保持开启以保证注册质量，从而让 L2 说话人硬门更可靠。',
  'pages.systemConfig.info.speakerLockTtlSec': '【L2 参数】说话人锁定时长（秒）。锁定期内第三方低相关插话会被跳过。',
  'pages.systemConfig.info.speakerLockTtlAfterTtsSec': '【L2 参数】TTS 播报结束后额外延长的锁定时长（秒），减少播报后被旁人抢走。',
  'pages.systemConfig.info.speakerSwitchConfirmRounds': '【L2 参数】中等相关第三方需连续确认的轮次，达到后才切换对话人；高相关仍可立刻换人。',
  'pages.systemConfig.info.intentMergeEnabled': '【L3】主对话挂载 dialog.no_reply：模型判断「不是对本设备说」时可静默不回（同一次生成，零额外调用）。依赖总开关。开了之后灰区应交给模型。保存即时生效。日志 layer=L3。建议通用对话开；儿童陪伴可在智能体强制关。',
  'pages.systemConfig.info.intentMergeOnlyNoSpeaker': '【L3 收紧项】开=仅当设备无声纹能力时才注入 no_reply。但若同时开了 L2.5，服务端仍会挂 no_reply（避免灰区既无L3又退回短语硬拦）。推荐：关（有声纹也挂L3）。灰度试跑才开。',
  'pages.systemConfig.info.intentMergePrompt': '【L3 提示词】拼入主对话的「是否回复」规则。原则应是：拿不准就回复；仅高置信旁人互聊/寒暄才 no_reply。留空保存会回填服务端默认文案；过严旧文案会自动升级。',
  'pages.systemConfig.info.contextGateEnabled': '【L2.5】零模型上下文门。与 L3 关系：若已开 IntentMerge，L2.5 不再靠短语名单硬拦，灰区交 L3；未开 IntentMerge 时才用寒暄/媒体旁白等廉价规则兜底。依赖总开关。日志 layer=L2.5。推荐与 IntentMerge 一起开。',
  'pages.systemConfig.info.contextGateRecentTurns': '【L2.5 参数】判定「接续上文」时参考的最近对话轮数。接续命中则放行进主对话。默认 2；调大更易放行。',
  'pages.systemConfig.info.contextGateShortCjk': '【L2.5 参数】CJK 短句字数阈值（历史兼容项）。当前有 IntentMerge 时灰区主要交 L3，该阈值影响变小。默认 12。',
  'pages.systemConfig.info.contextGateShortLatin': '【L2.5 参数】拉丁语短句词数阈值（历史兼容项）。有 IntentMerge 时影响变小。默认 8。',
  'pages.systemConfig.info.staticDir': 'Web 静态资源目录（web.static_dir）。',
  'pages.systemConfig.info.storeType': '认证存储类型：memory（内存）/ file / redis 等，与 config.yaml 中 server.auth.store.type 一致。',
  'pages.systemConfig.info.submitAgentIdToLLM': '开启此项后，请求llm时，会在用户角色的对话内容尾部添加额外信息：[系统信息: 智能体ID={agentId}，设备ID={deviceId}]，某些模型可能会利用这些信息优化回答。',
  'pages.systemConfig.info.token': 'Token用于客户端的签名认证，也用于基于openid的服务端转发请求验证',
  'pages.systemConfig.info.toutiaoAppCode': '阿里云云市场「新闻头条」API 的 AppCode。',
  'pages.systemConfig.info.udpEnableReliability': '是否启用 UDP 可靠性相关扩展（依固件与服务端实现）。',
  'pages.systemConfig.info.udpIp': '你的服务器公网IP地址，客户端通过udp连接到服务端。这个地址会通过hello消息发给客户端，由客户端连接使用。',
  'pages.systemConfig.info.udpMaxPacketSize': 'UDP 单包最大字节数。',
  'pages.systemConfig.info.udpPort': 'UPD传输的监听端口，默认使用8100端口',
  'pages.systemConfig.info.udpSessionTimeout': 'UDP 会话超时时间字符串，如 30s。',
  'pages.systemConfig.info.udpShowPort': '发给客户端的UPD端口，通常和udpPort相同，不用特别修改。如果你的服务器有端口转发，可以设置为转发前的端口。',
  'pages.systemConfig.info.useDeviceCode': '是否启用设备代码功能。启用后新注册的每台设备会生成一个6位数字的设备代码，目前dify大模型需要这个代码作为用户标识，如需使用dify，建议开启此项。',
  'pages.systemConfig.info.useDeviceConversationID': '会话ID默认绑定到Agent智能体，用于加载历史对话，所有绑定该智能体的设备共用一个会话ID。但某些情况需要每个设备单独维护会话ID，如需每个设备单独维护会话ID，请开启此项。',
  'pages.systemConfig.info.useShortTermMemory': '开启后，系统使用短期记忆机制，每轮对话后更新短期记忆。关闭则不使用短期记忆。',
  'pages.systemConfig.info.userTotalQuota': '用户总额度，0表示不限制额度。用户使用额度如果超过总额度，将无法继续对话，提示用户“今日额度已用完，请联系管理员”',
  'pages.systemConfig.info.vadInterrupt': '本地帧级 VAD 打断：realtime 模式下用户开口可尽快停止 TTS/LLM，与 gRPC 切段 VAD 并行。',
  'pages.systemConfig.info.validTokens': '有效的Token列表，暂未实现该功能',
  'pages.systemConfig.info.visionPrompt': '视觉识别提示词前缀（vision_prompt），服务端 /vision 调用 VLLLM 时注入。',
  'pages.systemConfig.info.visionUrl': '用于前端照片视觉识别的地址，一般为https://你的域名/api/vision，或者http://你的ip:8080/api/vision',
  'pages.systemConfig.info.voiceCloneCommerce': '音色克隆商业化：次数包、微信支付价格与限购等（与 recharge 模块配合）。',
  'pages.systemConfig.info.voiceCloneEnable': '开启后，前端将显示声音克隆相关功能。',
  'pages.systemConfig.info.weatherAppCode': '阿里云云市场「七天天气预报」API 的 AppCode。',
  'pages.systemConfig.info.weatherForecastDays': '多日天气预报最多返回天数（0 表示不按配置截断）。',
  'pages.systemConfig.info.todoOverdueGraceMinutes': '待办提醒过期后的宽限分钟数：超过后周期待办推进下一轮，一次性待办自动完成。默认 60。',
  'pages.systemConfig.info.webPort': 'Web服务监听的端口，默认使用8080端口，确保该端口未被占用',
  'pages.systemConfig.info.webSocketEnabled': '启用WebSocket传输方式，客户端通过wss/ws连接到服务端，连接稳定，建议开启',
  'pages.systemConfig.info.websocketAddress': 'ota请求时发送给前端的WebSocket地址，一般为wss://你的域名/ws，或者ws://你的ip:8080/ws',
  'pages.systemConfig.info.xiaozhiApiDomain': '小智相关 API 域名（xiaozhi.api_domain），用于 OTA/对接等场景。',
  'pages.systemConfig.injectPetMetricsToLlm': '注入宠物指标到 LLM',
  'pages.systemConfig.intentKeywords': '意图关键词（子串匹配，回车添加）',
  'pages.systemConfig.ipAddress': 'IP地址',
  'pages.systemConfig.jokeAppCode': '笑话 AppCode',
  'pages.systemConfig.kbUploadArchiveDir': '知识库上传归档根目录',
  'pages.systemConfig.keepConversationId': '保持会话ID',
  'pages.systemConfig.kbUnit': 'KB',
  'pages.systemConfig.toolContentMapAdd': '添加工具',
  'pages.systemConfig.toolContentMapKbPlaceholder': 'KB',
  'pages.systemConfig.toolContentMapToolNamePlaceholder': '工具名（如 realtime_search）',
  'pages.systemConfig.toolContentMaxBytes': '工具内容长度上限(KB)',
  'pages.systemConfig.toolContentMaxBytesMap': '工具差异化上限',
  'pages.systemConfig.toolContentMaxBytesMin': '至少 1KB（约 320 字）',
  'pages.systemConfig.toolContentMaxBytesPlaceholder': '2 ≈ 约650字',
  'pages.systemConfig.knowledgeBaseDivider': '知识库',
  'pages.systemConfig.knowledgeBaseMaxDocumentsPerKb': '单库文档数量上限',
  'pages.systemConfig.knowledgeBaseMaxPerUser': '每用户知识库数量上限',
  'pages.systemConfig.knowledgeBaseServerAddr': '知识库服务器地址',
  'pages.systemConfig.knowledgeBaseServerAddrPlaceholder': '请输入知识库服务器地址，如：http://localhost:8060',
  'pages.systemConfig.layeredMemory': '分层记忆（兼容）',
  'pages.systemConfig.listenPortRequired': '请填写监听端口',
  'pages.systemConfig.llmCommercialDefault': 'LLM（商业默认）',
  'pages.systemConfig.llmContextLimit': '大模型上下文限制',
  'pages.systemConfig.llmContextLimitEnabled': '启用上下文裁剪',
  'pages.systemConfig.llmContextLimitInject': '注入段策略',
  'pages.systemConfig.llmContextLimitLog': '每次打印上下文大小',
  'pages.systemConfig.llmContextLimitRatio': '窗口使用比例',
  'pages.systemConfig.llmContextLimitReserved': '输出预留 Token',
  'pages.systemConfig.llmContextLimitReservedPlaceholder': '0 = 使用各模型 max_tokens',
  'pages.systemConfig.llmContextLimitStrict': '工具白名单（永不精简）',
  'pages.systemConfig.llmCtxDiary': '日记生成预算',
  'pages.systemConfig.llmCtxIdentity': '身份采集预算',
  'pages.systemConfig.llmCtxMeeting': '会议摘要预算',
  'pages.systemConfig.llmCtxRewrite': '搜索词改写预算',
  'pages.systemConfig.llmCtxSummary': '记忆总结预算',
  'pages.systemConfig.llmCtxTitle': '标题生成预算',
  'pages.systemConfig.llmOpenSourceDefault': 'LLM（开源默认）',
  'pages.systemConfig.loadFailed': '加载失败: {error}',
  'pages.systemConfig.logAlertDesc': '更改日志配置后需要重启服务才能生效。',
  'pages.systemConfig.logAlertTitle': '日志配置说明',
  'pages.systemConfig.logCardTitle': '日志配置',
  'pages.systemConfig.logDirPlaceholder': '日志文件目录',
  'pages.systemConfig.logDirRequired': '请输入日志目录',
  'pages.systemConfig.logFileNameRequired': '请输入日志文件名',
  'pages.systemConfig.logLevelRequired': '请选择日志级别',
  'pages.systemConfig.masterSwitch': '总开关',
  'pages.systemConfig.maxPacketSize': '最大包长',
  'pages.systemConfig.mcpFunctionsAlertDesc': '本地MCP是服务内置的功能，目前仅支持 time、exit、play_music、switch_agent，更多功能需要等待服务器更新添加。',
  'pages.systemConfig.mcpFunctionsAlertTitle': '本地MCP功能说明',
  'pages.systemConfig.mcpFunctionsCardTitle': '本地MCP功能配置',
  'pages.systemConfig.mcpNamePlaceholder': '例如：Home Assistant',
  'pages.systemConfig.mcpNameRequired': '请输入MCP名称',
  'pages.systemConfig.memoryCollectionDays': '记忆收集期（天）',
  'pages.systemConfig.memoryCollectionDaysPlaceholder': '0 表示不按天限制',
  'pages.systemConfig.middleTierRole': '中间层约束提示',
  'pages.systemConfig.minEvidence': '最少证据条数',
  'pages.systemConfig.miscPanelTitle': '云市场 AppCode / 宠物指标',
  'pages.systemConfig.modalAddTitle': '添加{target}',
  'pages.systemConfig.modalEditTitle': '编辑{target}',
  'pages.systemConfig.modalTarget.externalMcp': '外部MCP',
  'pages.systemConfig.modalTarget.localMcpFunction': '本地MCP功能',
  'pages.systemConfig.modalTarget.quickReplyWord': '快捷回复词',
  'pages.systemConfig.modalTarget.role': '角色',
  'pages.systemConfig.mqttConfig': 'MQTT配置',
  'pages.systemConfig.mqttListenPort': 'MQTT监听端口',
  'pages.systemConfig.nameMaxLength': '名称长度不能超过80个字符',
  'pages.systemConfig.noDescription': '暂无描述',
  'pages.systemConfig.noLimitPlaceholder': '0表示不限制',
  'pages.systemConfig.notifyDeviceOnMcpTool': 'MCP 工具前通知设备',
  'pages.systemConfig.observationPool': '长期记忆观察池',
  'pages.systemConfig.ocrApiKey': 'OCR 实例 API Key',
  'pages.systemConfig.ocrApiKeyPlaceholder': '留空保存则不改写已保存的密钥',
  'pages.systemConfig.ocrDivider': '知识库 OCR 索引专用实例（可选）',
  'pages.systemConfig.ocrServerAddr': 'OCR 索引服务地址',
  'pages.systemConfig.ocrServerAddrPlaceholder': '留空则不启用；例如 http://127.0.0.1:8061',
  'pages.systemConfig.ocrTimeoutSeconds': 'OCR 实例 HTTP 超时（秒）',
  'pages.systemConfig.openSourceDeviceDefaultLlm': '开源设备默认 LLM',
  'pages.systemConfig.operationFailed': '操作失败',
  'pages.systemConfig.operationFailedDetail': '操作失败: {detail}',
  'pages.systemConfig.optional': '可选',
  'pages.systemConfig.originalListPriceFen': '划线原价(分)',
  'pages.systemConfig.pageAlertDesc': '在这里您可以管理系统的各项配置，包括应用程序设置、服务器配置、认证设置等。修改配置后请及时保存。',
  'pages.systemConfig.pageAlertTitle': '配置管理说明',
  'pages.systemConfig.pageSubtitle': '管理系统的各项配置参数',
  'pages.systemConfig.pageTitle': '系统配置管理',
  'pages.systemConfig.pendingOrderLimitPerUser': '每用户待支付订单上限',
  'pages.systemConfig.poolCheckInterval': '检查间隔',
  'pages.systemConfig.poolMaxSize': '最大',
  'pages.systemConfig.poolMinSize': '最小',
  'pages.systemConfig.poolPanelTitle': '连接池（pool_config / mcp_pool_config）',
  'pages.systemConfig.poolRefillSize': '补满批量',
  'pages.systemConfig.poolRefillSizeMcp': 'refill 批量',
  'pages.systemConfig.portNotZeroPlaceholder': '请填写端口号，不能为0',
  'pages.systemConfig.portRequired': '请输入端口',
  'pages.systemConfig.priceFen': '售价(分)',
  'pages.systemConfig.promotionMinConversations': '观察池晋升最少会话数',
  'pages.systemConfig.quantityRequired': '请输入数量',
  'pages.systemConfig.quickReply.addWord': '添加回复词',
  'pages.systemConfig.quickReplyCardTitle': '快捷回复词',
  'pages.systemConfig.quickReplyWordRequired': '请输入快捷回复词',
  'pages.systemConfig.quotaNonNegative': '额度不能为负数',
  'pages.systemConfig.quotaPerPurchase': '每单次数',
  'pages.systemConfig.recharge.apiV3Key': 'APIv3 密钥（留空或 *** 不改）',
  'pages.systemConfig.recharge.cardTitle': '充值与微信支付',
  'pages.systemConfig.recharge.certSerialNo': '商户证书序列号',
  'pages.systemConfig.recharge.disableRefundOnSimFail': '物联充值失败时不自动微信退款',
  'pages.systemConfig.recharge.enabled': '启用充值模块',
  'pages.systemConfig.recharge.feeBearer': '手续费承担 platform|user',
  'pages.systemConfig.recharge.feeRate': '费率 fee_rate',
  'pages.systemConfig.recharge.mchId': '商户号 mch_id',
  'pages.systemConfig.recharge.notifyUrl': '支付结果 notify_url',
  'pages.systemConfig.recharge.privateKeyPath': '商户私钥 PEM 路径',
  'pages.systemConfig.recharge.refundNotifyUrl': '退款 notify_url（可选）',
  'pages.systemConfig.recharge.simPlatformsDivider': '物联平台 sim_platforms（JSON）',
  'pages.systemConfig.recharge.simPlatformsJson': '一级代理配置对象 JSON',
  'pages.systemConfig.recharge.simPlatformsJsonInvalid': '需为合法 JSON 对象',
  'pages.systemConfig.recharge.wechatEnabled': '启用微信支付',
  'pages.systemConfig.recharge.wechatPayDivider': '微信支付 wechat_pay',
  'pages.systemConfig.recharge.wechatPublicKeyId': '微信支付公钥 ID',
  'pages.systemConfig.recharge.wechatPublicKeyPath': '微信支付公钥 PEM 路径',
  'pages.systemConfig.reliabilityExtension': '可靠性扩展',
  'pages.systemConfig.reloadFailed': '重载失败: {error}',
  'pages.systemConfig.reloadFailedMsg': '重载失败',
  'pages.systemConfig.reloadVoiceScripts': '重载话术库缓存',
  'pages.systemConfig.renamePlaceholder': '如需重命名请输入新名称',
  'pages.systemConfig.replyWord': '回复词',
  'pages.systemConfig.replyWordPlaceholder': '如：我在',
  'pages.systemConfig.replyWordRequired': '请输入回复词',
  'pages.systemConfig.requirePaymentForClone': '克隆需先购买',
  'pages.systemConfig.retryCount': '重试次数',
  'pages.systemConfig.roleDescLength': '角色描述长度应在5-500个字符之间',
  'pages.systemConfig.roleDescRequired': '请输入角色描述',
  'pages.systemConfig.roleNameLength': '角色名称长度应在2-50个字符之间',
  'pages.systemConfig.roleNamePattern': '角色名称只能包含字母、数字、中文、下划线和短横线',
  'pages.systemConfig.roleNameRequired': '请输入角色名称',
  'pages.systemConfig.rolesCardTitle': '角色配置',
  'pages.systemConfig.routeAllSentences': '每句外转(慎用)',
  'pages.systemConfig.rsPanelTitle': '联网搜索（realtime_search）',
  'pages.systemConfig.sampleRate': '采样率',
  'pages.systemConfig.saveAppConfig': '保存应用配置',
  'pages.systemConfig.saveConfig': '保存配置',
  'pages.systemConfig.saveConfigSuccess': '配置保存成功',
  'pages.systemConfig.saveFailed': '保存失败: {error}',
  'pages.systemConfig.saveKbUploadOriginal': '保存知识库上传原始文件',
  'pages.systemConfig.saveTtsAudio': '保存历史回放TTS',
  'pages.systemConfig.selectLlmConfigName': '选择 LLM 配置名',
  'pages.systemConfig.selectedModuleDivider': 'selected_module（当前选用模块名）',
  'pages.systemConfig.serpEngines': 'SERP 引擎列表',
  'pages.systemConfig.serpEnginesPlaceholder': '如 baidu、360',
  'pages.systemConfig.serpStrategy': 'SERP 策略',
  'pages.systemConfig.serverVersion': '服务版本号',
  'pages.systemConfig.sessionTimeout': '会话超时',
  'pages.systemConfig.sessionTimeoutPlaceholder': '如 30s',
  'pages.systemConfig.showPortNotZero': '端口号不能为0，请填写有效端口',
  'pages.systemConfig.showPortRequired': '请填写显示端口',
  'pages.systemConfig.silenceResetMs': '静音重置(ms)',
  'pages.systemConfig.simPlatformsJsonError': '物联平台 JSON 解析失败，请检查 simPlatformsJson',
  'pages.systemConfig.sortWeight': '排序权重',
  'pages.systemConfig.speakerRecognizeAddr': '声纹识别服务器地址',
  'pages.systemConfig.speakerRecognizeAddrPlaceholder': '请输入声纹识别服务器地址，如：localhost:8848',
  'pages.systemConfig.speakerRecognizeDivider': '声纹识别',
  'pages.systemConfig.staticDir': '静态资源目录',
  'pages.systemConfig.staticDirPlaceholder': '如 ./static 或 web.static_dir',
  'pages.systemConfig.statusColumn': '状态',
  'pages.systemConfig.storeType': '存储类型',
  'pages.systemConfig.storeTypeRequired': '请选择或填写存储类型',
  'pages.systemConfig.submitAgentIdToLlm': '向LLM提交Agent ID',
  'pages.systemConfig.switchOff': '关闭',
  'pages.systemConfig.switchOn': '开启',
  'pages.systemConfig.tab.application': '应用配置',
  'pages.systemConfig.tab.auth': '认证配置',
  'pages.systemConfig.tab.data': '数据配置',
  'pages.systemConfig.tab.exitCommands': '退出指令',
  'pages.systemConfig.tab.externalMcp': '外部MCP配置',
  'pages.systemConfig.tab.localMcp': '本地MCP功能',
  'pages.systemConfig.tab.log': '日志配置',
  'pages.systemConfig.tab.quickReply': '快捷回复',
  'pages.systemConfig.tab.recharge': '充值/支付',
  'pages.systemConfig.tab.roles': '角色配置',
  'pages.systemConfig.tab.transport': '传输配置',
  'pages.systemConfig.tab.web': 'Web配置',
  'pages.systemConfig.tab.yaml': '完整YAML（只读）',
  'pages.systemConfig.timeoutSec': '超时(秒)',
  'pages.systemConfig.toutiaoAppCode': '头条 AppCode',
  'pages.systemConfig.transportCardTitle': '传输层配置',
  'pages.systemConfig.transportLayerTitle': '{name} 传输层',
  'pages.systemConfig.udpConfig': 'UDP配置',
  'pages.systemConfig.udpListenPort': 'UDP监听端口',
  'pages.systemConfig.updateSuccess': '更新成功',
  'pages.systemConfig.useDeviceConversationId': '使用设备会话ID',
  'pages.systemConfig.vadPanelTitle': 'VAD 打断（vad_interrupt）',
  'pages.systemConfig.validPortRequired': '请填写有效端口',
  'pages.systemConfig.vccPanelTitle': '音色克隆商业化（voice_clone_commerce）',
  'pages.systemConfig.vectorMemory': '向量长期记忆',
  'pages.systemConfig.visionPromptPrefix': '视觉提示词前缀',
  'pages.systemConfig.visionServiceUrl': '视觉服务URL',
  'pages.systemConfig.voiceScriptsReloaded': '话术库已重载（意图 {intents}，条目 {entries}）',
  'pages.systemConfig.weatherAppCode': '天气 AppCode',
  'pages.systemConfig.webCardTitle': 'Web界面配置',
  'pages.systemConfig.webServicePort': 'Web服务端口',
  'pages.systemConfig.webrtcVadMode': 'WebRTC VAD 模式(0-3)',
  'pages.systemConfig.websocketAddress': 'WebSocket地址',
  'pages.systemConfig.websocketAddressRequired': '请输入WebSocket地址',
  'pages.systemConfig.websocketPlaceholder': 'ws://你的ip:8000',
  'pages.systemConfig.xiaozhiApiDomain': '小智 API 域名',
  'pages.systemConfig.yaml.cardTitle': '完整 YAML（server_configs，只读）',
  'pages.systemConfig.yaml.loadBtn': '从服务器加载',
  'pages.systemConfig.yaml.placeholder': '点击「从服务器加载」查看当前配置',
  'pages.systemConfig.yamlAlignedExtras': '与 server_configs / YAML 对齐的扩展项',
  'pages.systemConfig.yamlLoadedSuccess': '已从服务器加载当前 YAML',
  'pages.systemConfig.navigationAmapKey': '导航高德 Key',
  'pages.systemConfig.info.navigationAmapKey': '高德 Web 服务 Key（驾车路线规划导航）。用于 navigation_route 工具。留空则降级复用 location_report 的高德 Key。',
  'pages.systemConfig.yourIp': '你的IP',
};
